import React, { Fragment } from 'react';
import Modal from '../../../../../components/Modal';
import InfoTable from '../../../../../components/table/InfoTable';
import TextAreaForm from '../../../../../components/form/TextAreaForm';
import SearchAddress from '../../../../../components/SearchAddress';
import InputForm from '../../../../../components/form/InputForm';
import SelectForm from '../../../../../components/form/SelectForm';
import { MAXIMUM_NUMBER_OF_INVOICE_NUMBER } from '../../../../../constants/service/common/utilConstants';
import { INVALID_MOBILE_PHONE_MESSAGE } from '../../../../../constants/service/invalidMsg/commonInvalidMsg';
import {
  ORDER_DELIVERY_TYPE,
  MAXIMUM_NUMBER_OF_SHIPPING_MESSAGE_TEXT,
  ORDER_ITEM_DELIVERY_TYPE_SEARCH_SELECT_LIST,
} from '../../../../../constants/service/app/orderConstants';
import { numberKeyPress, setPhoneFormat, setNumberWithComma } from '../../../../../lib/common';
import { formRequiredRules } from '../../../../../lib/formRules';
import { REX_PHONE, REX_EXCEPT_NUMBER } from '../../../../../lib/rex';
import './CompleteExchangeModal.scss';

const CompleteExchangeModal = (props) => {
  const {
    form,
    isOpen,
    data,
    closeModal,
    setData,
    onSubmit,
    exchangeDeliveryType,
    exchangeDeliveryAgentId,
    exchangeInvoiceNumber,
    exchangeBuyerPhone,
    exchangeRecipientPhone,
    address,
    message,
  } = props;
  const { deliveryAgentList, orderItemId, productName, productPrice } = data;

  return (
    <Modal
      title="교환 재배송 처리"
      isOpen={isOpen}
      width={660}
      height={600}
      isFooter={true}
      okText="교환 재배송 처리"
      onOk={() => onSubmit()}
      onClose={() => closeModal()}
    >
      <div className="complete-exchange-modal-wrap">
        <div className="complete-exchange-info">
          <div>* 함께 처리 가능한 상품 주문건이 모두 노출됩니다.</div>
        </div>

        <div className="title">교환 정보 확인</div>

        <InfoTable className="selected-order-item-list-table">
          <thead>
            <tr>
              <th>상품 주문번호</th>
              <th>상품명</th>
              <th>상품 가격(정가)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="tc">{orderItemId}</td>
              <td className="tc">{productName}</td>
              <td className="tc">{setNumberWithComma(productPrice, '원')}</td>
            </tr>
          </tbody>
        </InfoTable>

        <InfoTable>
          <tbody>
            <tr>
              <td className="tc label">배송방법</td>
              <td className="tl" colSpan={3}>
                <SelectForm
                  form={form}
                  name="exchangeDeliveryType"
                  rules={[formRequiredRules(true, null, false)]}
                  list={ORDER_ITEM_DELIVERY_TYPE_SEARCH_SELECT_LIST}
                  initialValue={exchangeDeliveryType}
                  size="default"
                  isTable={true}
                  onChange={(value) =>
                    setData({
                      name: 'exchangeDeliveryType',
                      value,
                    })
                  }
                />
              </td>
            </tr>
            {exchangeDeliveryType === ORDER_DELIVERY_TYPE.PARCEL_DELIVERY ? (
              <Fragment>
                <tr>
                  <td className="tc label">택배사</td>
                  <td className="tl" colSpan={3}>
                    <SelectForm
                      form={form}
                      name="exchangeDeliveryAgentId"
                      rules={[formRequiredRules(true, null, false)]}
                      list={deliveryAgentList}
                      initialValue={exchangeDeliveryAgentId}
                      size="default"
                      isTable={true}
                      onChange={(value) =>
                        setData({
                          name: 'exchangeDeliveryAgentId',
                          value,
                        })
                      }
                    />
                  </td>
                </tr>
                <tr>
                  <td className="tc label">송장번호</td>
                  <td className="tl" colSpan={3}>
                    <InputForm
                      form={form}
                      name="exchangeInvoiceNumber"
                      rules={[formRequiredRules(true, null)]}
                      getValueFromEvent={(value) => value.replace(REX_EXCEPT_NUMBER, '')}
                      onKeyUp={(e) => numberKeyPress(e)}
                      initialValue={exchangeInvoiceNumber}
                      maxLength={MAXIMUM_NUMBER_OF_INVOICE_NUMBER}
                      onChange={(value) =>
                        setData({
                          name: 'exchangeInvoiceNumber',
                          value: value.replace(REX_EXCEPT_NUMBER, ''),
                        })
                      }
                    />
                  </td>
                </tr>
              </Fragment>
            ) : null}
            <tr>
              <td className="tc label">구매자 연락처</td>
              <td className="tl" colSpan={3}>
                <InputForm
                  form={form}
                  name="exchangeBuyerPhone"
                  rules={[formRequiredRules(true, null), { pattern: REX_PHONE, message: INVALID_MOBILE_PHONE_MESSAGE }]}
                  initialValue={setPhoneFormat(exchangeBuyerPhone)}
                  getValueFromEvent={(value) => setPhoneFormat(value)}
                  onChange={(value) =>
                    setData({
                      name: 'exchangeBuyerPhone',
                      value,
                    })
                  }
                />
              </td>
            </tr>
            <tr>
              <td className="tc label">수취인 연락처</td>
              <td className="tl" colSpan={3}>
                <InputForm
                  form={form}
                  name="exchangeRecipientPhone"
                  rules={[formRequiredRules(true, null), { pattern: REX_PHONE, message: INVALID_MOBILE_PHONE_MESSAGE }]}
                  initialValue={setPhoneFormat(exchangeRecipientPhone)}
                  getValueFromEvent={(value) => setPhoneFormat(value)}
                  onChange={(value) =>
                    setData({
                      name: 'exchangeRecipientPhone',
                      value,
                    })
                  }
                />
              </td>
            </tr>
            <tr>
              <td className="tc label">배송지</td>
              <td className="tl" colSpan={3}>
                <SearchAddress
                  address={address}
                  onSelect={(data) =>
                    setData({
                      name: 'address',
                      value: {
                        ...address,
                        ...data,
                      },
                    })
                  }
                />
                <InputForm
                  form={form}
                  name="address-line2"
                  rules={[formRequiredRules(true, undefined, true)]}
                  initialValue={address.line2}
                  onChange={(value) =>
                    setData({
                      name: 'address',
                      value: {
                        ...address,
                        line2: value,
                      },
                    })
                  }
                  placeholder="상세 주소"
                />
              </td>
            </tr>
            <tr>
              <td className="tc label">배송메시지</td>
              <td className="tl" colSpan={3}>
                <TextAreaForm
                  form={form}
                  name="message"
                  initialValue={message}
                  onChange={(value) =>
                    setData({
                      name: 'message',
                      value,
                    })
                  }
                  maxLength={MAXIMUM_NUMBER_OF_SHIPPING_MESSAGE_TEXT}
                />
              </td>
            </tr>
          </tbody>
        </InfoTable>
      </div>
    </Modal>
  );
};

export default CompleteExchangeModal;
